import DataRoomTeam from './DataRoomTeam.component';

export default DataRoomTeam;